import { CounterpartyLimitViewModel, TradingCounterpartyLegalHierarchyOwnership } from './CounterpartyLimits.component.model';
import { ExchangeRateEF, TradingEntityLegalHierarchyOwnership } from '../../../../limit-management/TradingLimits.model';
import { ConsoleLoggerService } from '../../../../common/LoggerService/console-logger.service';

export class CounterpartyLimitsCommonManager {
  __iCptysUnderHierarchy: number[] = [];
  __oDataSource: CounterpartyLimitViewModel[] = [];
  __trvInstance: any = {};
  __oLogger: ConsoleLoggerService;
  //validates immidiate parents
  constructor(oSource: CounterpartyLimitViewModel[], trvInstance: any,  oLogger: ConsoleLoggerService) {
    this.__oDataSource = oSource;
    this.__trvInstance = trvInstance;
    this.__oLogger = oLogger;
  }
  public validateImmidiateParent(oDataSource: CounterpartyLimitViewModel[], oParentLimit: CounterpartyLimitViewModel, bValidated: boolean, sMessage: string, oSystemSettings: any, oExchangeRateEFs: ExchangeRateEF[]) {
    try {
      for (let i = (oSystemSettings[0].CounterpartyLimitMaxTenure - 1); i >= 0; i--) {//CRD-420-Pawan Prajapati
        let iSum = 0;
        oDataSource.forEach(x => {
          if (x.DataValues[i].LimitValue) {
            iSum = (oParentLimit ? (iSum + (this.currencyConversion(x.DataValues[i].LimitValue, x.lLimitValueCurrencyId, oParentLimit.lLimitValueCurrencyId, oExchangeRateEFs))) : (iSum + x.DataValues[i].LimitValue)); //iSum + x.DataValues[i].LimitValue;
          }
        });
        if (oParentLimit && oParentLimit.DataValues[i] && oParentLimit.DataValues[i].LimitValue < iSum) {
          bValidated = false;
          sMessage = oParentLimit.IsOverall === 1 ? 'The sum of Child\'s Category Overall Limits exceeds the Parent\'s Category Overall Limit for  Counterparty: ' + oParentLimit.TradingCounterpartyName + ' , Our Entity: ' + oParentLimit.TradingEntityName + ' , Limit Type: ' + oParentLimit.LimitTypeName + ' and Trading Category: ' + oParentLimit.TradingCategoryName + '. Please correct the limit value.' : 'The sum of Child\'s Overall Limits exceeds the Parent\'s Overall Limit for  Counterparty: ' + oParentLimit.TradingCounterpartyName + ' , Our Entity: ' + oParentLimit.TradingEntityName + ' , Limit Type: ' + oParentLimit.LimitTypeName + ' and Trading Category: ' + oParentLimit.TradingCategoryName + '. Please correct the limit value.';
          this.generateAlerts(oParentLimit, i, sMessage);
        }
      }

      let oLimit = this.__oDataSource.find(x => x.lCounterpartyLimitId === oParentLimit.lCounterpartyLimitId);
      let sValidationMessage = "";
      oLimit.CounterpartyLimitWarnings.reverse();
      if (oLimit && oLimit.CounterpartyLimitWarnings.length > 0 && oLimit.CounterpartyLimitWarnings.length === 1) {
        sValidationMessage = 'The sum of Child\'s' + ((oParentLimit.IsOverall === 1) ? ' Category' : '') + ' Overall Limits exceeds the Parent\'s' + ((oParentLimit.IsOverall === 1) ? ' Category' : '') + ' Overall Limit for the Month of ' + oLimit.CounterpartyLimitWarnings[0].ColumnName + '. Please correct the limit values.'
        oLimit.CounterpartyLimitWarnings.forEach(x => { x.sMessage = sValidationMessage });
      }
      else if (oLimit && oLimit.CounterpartyLimitWarnings.length > 0 && oLimit.CounterpartyLimitWarnings.length === 2) {
        sValidationMessage = 'The sum of Child\'s' + ((oParentLimit.IsOverall === 1) ? ' Category' : '') + ' Overall Limits exceeds the Parent\'s' + ((oParentLimit.IsOverall === 1) ? ' Category' : '') + ' Overall Limit for the Month of ' + oLimit.CounterpartyLimitWarnings[0].ColumnName + ' and ' + oLimit.CounterpartyLimitWarnings[1].ColumnName + '. Please correct the limit values.'
        oLimit.CounterpartyLimitWarnings.forEach(x => { x.sMessage = sValidationMessage });
      }
      else if (oLimit && oLimit.CounterpartyLimitWarnings.length > 0 && oLimit.CounterpartyLimitWarnings.length > 2) {
        sValidationMessage = 'The sum of Child\'s' + ((oParentLimit.IsOverall === 1) ? ' Category' : '') + ' Overall Limits exceeds the Parent\'s' + ((oParentLimit.IsOverall === 1) ? ' Category' : '') + ' Overall Limit for the Month of ' + oLimit.CounterpartyLimitWarnings[0].ColumnName + ' and Subsequent period. Please correct the limit values.'
        oLimit.CounterpartyLimitWarnings.forEach(x => { x.sMessage = sValidationMessage });
      }
      sMessage = "";
      return { bValidated, sMessage, oLimit }
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while executing validate Immidiate Parent function.');
    }
  }

  //generate alerts during save
  public generateAlerts(oParentLimit: CounterpartyLimitViewModel, i: number, sMessage: string) {
    try {
      let oWarning: any = {};
      this.__trvInstance.instance.refresh();
      oWarning.ColumnName = oParentLimit.DataValues[i].ColumnName;
      oWarning.RowIndex = this.__trvInstance.instance.getRowIndexByKey(oParentLimit.lCounterpartyLimitId);//this.__oDataSource.indexOf(oParentLimit);
      oWarning.ColumnIndex = 0;//CRD-420-Pawan Prajapati
      oWarning.sMessage = sMessage;
      this.__oDataSource.find(x => x.lCounterpartyLimitId === oParentLimit.lCounterpartyLimitId).CounterpartyLimitWarnings.push(oWarning);
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while executing generate Alerts function.');
    }
  }

  //currency conversion to be done wrt overall limit currency
  currencyConversion(limitValue: any, fromCurrency: number, toCurrency: number, oExchangeRateEFs: ExchangeRateEF[]): number {
    try {
      let nReturn = limitValue;
      let nExchangeRate = 1;
      if (oExchangeRateEFs && oExchangeRateEFs.length > 0 && oExchangeRateEFs.find(x => x.lFromCurrencyId == fromCurrency && x.lToCurrencyId == toCurrency)) {
        nExchangeRate = oExchangeRateEFs.find(x => x.lFromCurrencyId == fromCurrency && x.lToCurrencyId == toCurrency).ConversionRate;
      }
      nReturn = this.roundToTwoDecimal(limitValue * nExchangeRate);//FB39932-Pawan Prajapati
      return nReturn;
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while executing currency Conversion function.');
    }
  }
  //FB39932-Pawan Prajapati
  roundToTwoDecimal(num) {
    try {
      return +(Math.round(num * 100) + "e-2");
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while executing round To Two Decimal function.');
    }
  }
  //Extracts counterparties from hierarchy
  ExtractCptys(parent: CounterpartyLimitViewModel, oCounterpartyLimitViewModels: CounterpartyLimitViewModel[], oDataSource: CounterpartyLimitViewModel[], __iCptysUnderHierarchy: number[]) {//CRD-592-Pawan Prajapati
    try {
      if (parent && oCounterpartyLimitViewModels.length > 0) {
        var oCounterpartyLimitViewModelChildren = [];
        oCounterpartyLimitViewModels.filter(x => x.lParentCounterpartyLimitId == parent.lCounterpartyLimitId).forEach(x => {
          x.TradingCategoryName !== 'Overall' ? oCounterpartyLimitViewModelChildren.unshift(x) : oCounterpartyLimitViewModelChildren.push(x);
        });

        for (var i = 0, l = oCounterpartyLimitViewModelChildren.length; i < l; ++i) {
          var child = oCounterpartyLimitViewModelChildren[i];

          if (__iCptysUnderHierarchy.filter(c => c == child.lCounterpartyLimitId).length == 0) {
            __iCptysUnderHierarchy.push(child.lCounterpartyLimitId);
          }
          if (oDataSource.filter(x => x.lParentCounterpartyLimitId == child.lCounterpartyLimitId).length > 0) {//CRD-592-Pawan Prajapati
            this.ExtractCptys(child, oDataSource.filter(x => x.lParentCounterpartyLimitId == child.lCounterpartyLimitId), oDataSource, __iCptysUnderHierarchy);//CRD-592-Pawan Prajapati
          }
        }
      }
      return __iCptysUnderHierarchy;
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while executing Extract Cptys function.');
    }
  }


  //build tree view for counterparty limit validation
  buildtree(oDatasource: CounterpartyLimitViewModel[], oTradingEntityLegalHierarchyOwnerships: TradingEntityLegalHierarchyOwnership[], oTradingCounterpartyLegalHierarchyOwnerships: TradingCounterpartyLegalHierarchyOwnership[]) {
    try {
      this.__oDataSource = oDatasource;

      this.__oDataSource.filter(z => z.TradingCategoryName === "Overall").forEach(x => {
        let oParentLimitWithSameEntity = this.__oDataSource.find(z => z.lTradingCounterpartyId == x.lParentTradingCounterpartyId && z.lOurEntityId == x.lOurEntityId && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB43985-Pawan Prajapati
        let oParentLimitWithParentEntity = this.__oDataSource.find(z => z.lTradingCounterpartyId == x.lParentTradingCounterpartyId && z.lOurEntityId == x.lParentTradingEntityId && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB43985-Pawan Prajapati

        let oParentLimitWithUltimateParentEntity = this.__oDataSource.find(z => z.lTradingCounterpartyId == x.lParentTradingCounterpartyId && z.lOurEntityId == oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB43985-Pawan Prajapati

        let oTopMostParentLimit = this.__oDataSource.find(z => z.lTradingCounterpartyId == oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && z.lOurEntityId == oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB43985-Pawan Prajapati

        if (oParentLimitWithSameEntity && x.lCounterpartyLimitId !== oParentLimitWithSameEntity.lCounterpartyLimitId) {
          x.lParentCounterpartyLimitId = oParentLimitWithSameEntity.lCounterpartyLimitId;
        }

        else if (oParentLimitWithParentEntity && !oParentLimitWithSameEntity && x.lCounterpartyLimitId !== oParentLimitWithParentEntity.lCounterpartyLimitId) {
          x.lParentCounterpartyLimitId = oParentLimitWithParentEntity.lCounterpartyLimitId;
        }

        else if (oParentLimitWithUltimateParentEntity && !oParentLimitWithParentEntity && !oParentLimitWithSameEntity && x.lCounterpartyLimitId !== oParentLimitWithUltimateParentEntity.lCounterpartyLimitId) {
          x.lParentCounterpartyLimitId = oParentLimitWithUltimateParentEntity.lCounterpartyLimitId;
        }

        else if (oTopMostParentLimit && !oParentLimitWithUltimateParentEntity && !oParentLimitWithParentEntity && !oParentLimitWithSameEntity && x.lCounterpartyLimitId !== oTopMostParentLimit.lCounterpartyLimitId && ((x.lParentTradingCounterpartyId == oTopMostParentLimit.lTradingCounterpartyId) || (x.lTradingCounterpartyId === oTopMostParentLimit.lTradingCounterpartyId))) {
          x.lParentCounterpartyLimitId = oTopMostParentLimit.lCounterpartyLimitId;
        }
        else {
          x.lParentCounterpartyLimitId = -1;
        }
      });

      this.__oDataSource.filter(z => z.IsOverall === 1).forEach(x => {
        let oParentLimitWithSameEntity = this.__oDataSource.find(z => z.lTradingCounterpartyId == x.lParentTradingCounterpartyId && z.lOurEntityId == x.lOurEntityId && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1);//FB43985-Pawan Prajapati
        let oParentLimitWithParentEntity = this.__oDataSource.find(z => z.lTradingCounterpartyId == x.lParentTradingCounterpartyId && z.lOurEntityId == x.lParentTradingEntityId && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1);//FB43985-Pawan Prajapati

        let oParentLimitWithUltimateParentEntity = this.__oDataSource.find(z => z.lTradingCounterpartyId == x.lParentTradingCounterpartyId && z.lOurEntityId == oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1);//FB43985-Pawan Prajapati

        let oTopMostParentLimit = this.__oDataSource.find(z => z.lTradingCounterpartyId == oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && z.lOurEntityId == oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1);//FB43985-Pawan Prajapati

        if (oParentLimitWithSameEntity && x.lCounterpartyLimitId !== oParentLimitWithSameEntity.lCounterpartyLimitId) {
          x.lCommodityParentCounterpartyLimitId = oParentLimitWithSameEntity.lCounterpartyLimitId;
        }

        else if (oParentLimitWithParentEntity && !oParentLimitWithSameEntity && x.lCounterpartyLimitId !== oParentLimitWithParentEntity.lCounterpartyLimitId) {
          x.lCommodityParentCounterpartyLimitId = oParentLimitWithParentEntity.lCounterpartyLimitId;
        }

        else if (oParentLimitWithUltimateParentEntity && !oParentLimitWithParentEntity && !oParentLimitWithSameEntity && x.lCounterpartyLimitId !== oParentLimitWithUltimateParentEntity.lCounterpartyLimitId) {
          x.lCommodityParentCounterpartyLimitId = oParentLimitWithUltimateParentEntity.lCounterpartyLimitId;
        }

        else if (oTopMostParentLimit && !oParentLimitWithUltimateParentEntity && !oParentLimitWithParentEntity && !oParentLimitWithSameEntity && x.lCounterpartyLimitId !== oTopMostParentLimit.lCounterpartyLimitId && ((x.lParentTradingCounterpartyId == oTopMostParentLimit.lTradingCounterpartyId) || (x.lTradingCounterpartyId === oTopMostParentLimit.lTradingCounterpartyId))) {
          x.lCommodityParentCounterpartyLimitId = oTopMostParentLimit.lCounterpartyLimitId;
        }
        else {
          x.lCommodityParentCounterpartyLimitId = -1;
        }
      });

      return this.__oDataSource;
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while executing build tree function.');
    }
  }

  //build tree view for our entity limit validation
  buildOETree(oDatasource: CounterpartyLimitViewModel[], oTradingEntityLegalHierarchyOwnerships: TradingEntityLegalHierarchyOwnership[], oTradingCounterpartyLegalHierarchyOwnerships: TradingCounterpartyLegalHierarchyOwnership[]) {
    try {
      this.__oDataSource = oDatasource;

      this.__oDataSource.filter(z => z.TradingCategoryName === "Overall").forEach(x => {
        let oParentLimit = this.__oDataSource.find(z => z.lOurEntityId == x.lParentTradingEntityId && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB43985-Pawan Prajapati
        //let oParentLimitWithParentEntity = this.__oDataSource.find(z => z.lTradingCounterpartyId == x.lParentTradingCounterpartyId && z.lOurEntityId == x.lParentTradingEntityId && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");
        let oTopMostParentLimit = this.__oDataSource.find(z => z.lTradingCounterpartyId == oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && z.lOurEntityId == oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB43985-Pawan Prajapati

        if (oParentLimit && x.lCounterpartyLimitId !== oParentLimit.lCounterpartyLimitId) {
          x.lParentCounterpartyLimitId = oParentLimit.lCounterpartyLimitId;
        }
        else if (oTopMostParentLimit && !oParentLimit && x.lCounterpartyLimitId !== oTopMostParentLimit.lCounterpartyLimitId) {
          x.lParentCounterpartyLimitId = oTopMostParentLimit.lCounterpartyLimitId;
        }
        else {
          x.lParentCounterpartyLimitId = -1;
        }
      });

      this.__oDataSource.filter(z => z.IsOverall === 1).forEach(x => {
        let oParentLimit = this.__oDataSource.find(z => z.lOurEntityId == x.lParentTradingEntityId && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1);//FB43985-Pawan Prajapati
        let oTopMostParentLimit = this.__oDataSource.find(z => z.lTradingCounterpartyId == oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && z.lOurEntityId == oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1);//FB43985-Pawan Prajapati

        if (oParentLimit && x.lCounterpartyLimitId !== oParentLimit.lCounterpartyLimitId) {
          x.lParentCounterpartyLimitId = oParentLimit.lCounterpartyLimitId;
        }
        else if (oTopMostParentLimit && !oParentLimit && x.lCounterpartyLimitId !== oTopMostParentLimit.lCounterpartyLimitId) {
          x.lParentCounterpartyLimitId = oTopMostParentLimit.lCounterpartyLimitId;
        }
        else {
          x.lParentCounterpartyLimitId = -1;
        }
      });

      return this.__oDataSource;
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while executing build OE Tree function.');
    }
  }
  //builds headroom order in the grid
  public buildHeadroomOrder(oDatasource: CounterpartyLimitViewModel[], __oDatasource: CounterpartyLimitViewModel[]) {
    try {
      let oResult = [];
      oDatasource.filter(x => x.TradingCategoryName === 'Overall' && (x.SubLimitTypeName === 'Permanent' || x.SubLimitTypeName === 'Temporary')).forEach(x => {
        let oItem = __oDatasource.find(z => z.lTradingCounterpartyId == x.lTradingCounterpartyId && z.TradingEntityName == x.TradingEntityName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName == 'Headroom' && z.SubLimitTypeName === 'Permanent');//FB43985-Pawan Prajapati
        if (oItem) {
          oItem.lParentCounterpartyLimitId = x.lParentCounterpartyLimitId;
          let iOverallIndex = __oDatasource.findIndex(z => z.lCounterpartyLimitId == x.lCounterpartyLimitId);
          let source = [];
          for (let i = 0; i < iOverallIndex; i++) {
            if (__oDatasource[i].lCounterpartyLimitId !== oItem.lCounterpartyLimitId) {
              source.unshift(oDatasource[i]);
            }
          }
          for (let i = iOverallIndex; i <= oDatasource.length; i++) {
            if (oDatasource[i]) {
              oResult.push(oDatasource[i]);
            }
          }
          if (oResult.findIndex(z => z.lCounterpartyLimitId == oItem.lCounterpartyLimitId) !== -1) {
            oResult.splice(oResult.findIndex(z => z.lCounterpartyLimitId == oItem.lCounterpartyLimitId), 1);
          }
          oResult.unshift(oItem);
          source.forEach(z => {
            if (z) {
              oResult.unshift(z);
            }
          });
          oDatasource = oResult;
          oResult = [];
        }
      });
      return oDatasource;
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while executing build Headroom Order function.');
    }
  }
}
